export const GET_COMMUNICATION_LIST_SUCCESS = "GET_COMMUNICATION_LIST_SUCCESS";